export default {
    feature_tab_edit_features: "Edit Features",
    feature_tab_show_in_web: "Show In Web",
    feature_tab_promiles: "Promiles",
    feature_tab_send_calc_odometer: "Send Calc Odometer",
    feature_tab_analytics: "Analytics",
    feature_tab_apu: "APU",
    feature_tab_hybrid: "Hybrid",
    feature_tab_vbus: "Vbus",
    feature_tab_jbus: "Jbus",
    feature_tab_show_ecu_speed: "Show ECU Speed",
    feature_tab_use_ecu_odometer: "Use ECU Odometer",
    feature_tab_driver_behavior: "Driver Behavior",
    feature_tab_edit_device: "Edit Device",
    feature_tab_the_device_has_been_edited: "The device has been edited",
    feature_tab_device_category: "Device Category",
    feature_tab_features: "Features",
    feature_tab_use_ecu_vin: "Use ECU Vin",
    feature_tab_device_name: "Device Name",
    feature_tab_asset: "Asset",
    feature_tab_fleet: "Fleet",
    feature_tab_timezone: "Time Zone",
    feature_tab_cariq: "Car IQ",
    feature_tab_install_status: "Installation Status",
    feature_tab_installed: "Installed",
    feature_tab_pending_install: "Pending Install",
    feature_tab_installed_on: "Installed On",
    feature_tab_installed_on_valid: "Select a valid installed on date first",
    feature_tab_select_date: "Select a date",
    feature_tab_tz_to_gps: "A change on the timezone will also apply to the paired device",
    feature_tab_tz_to_camera: "A change on the timezone will also apply to the camera device",
    feature_tab_tz_not_supported: "The selected timezone is not supported by the vidfleet configuration",
    feature_tab_carb: "Carb",
    feature_tab_billing_account: "Billing Account",
    feature_tab_use_ecu_engine_hours: "Use ECU Engine Hours",
}

